export const es = {
  stickerLibrary: {"builtin": "Incluidos", "mine": "Mis stickers", "help": "GIF o WebP de hasta 5 MB y 1024 × 1024 px.", "upload": "Subir sticker", "name": "Nombre del sticker", "save": "Guardar sticker", "cancel": "Cancelar", "loading": "Cargando stickers…", "retry": "No se pudo cargar. Haz clic para reintentar.", "empty": "Sube tu primer sticker para reutilizarlo en tus campañas.", "imageLimit": "El mensaje ya tiene 8 imágenes. Elimina una antes de agregar otro sticker de la biblioteca.", "rename": "Renombrar", "remove": "Eliminar", "confirmRemove": "¿Eliminar de la biblioteca? Las campañas existentes conservarán el sticker.", "failed": "No se pudo guardar el cambio. Inténtalo de nuevo.", "invalid": "Selecciona un GIF o WebP válido de hasta 5 MB y 1024 × 1024 px."},
  textBlockStyle: {"title": "Estilo del texto", "font": "Fuente", "size": "Tamaño (px)", "color": "Color de texto", "inherit": "Usar fuente del creativo", "bold": "Negrita", "italic": "Cursiva", "underline": "Subrayado", "reset": "Restablecer estilo"},
  richMessage: {backgroundColor: "Color de fondo", transparent: "Transparente", replaceEmoji: "Cambiar emoji", replaceSticker: "Cambiar sticker", addBlock: "Agregar bloque", replaceImage: "Cambiar", textHelp: "Escribe una parte del mensaje.", emojiHelp: "Elige un emoji para tu mensaje.", stickerHelp: "Agrega un sticker con movimiento.",gifHelp: "Los GIF se animan automáticamente. Máximo 5 MB y 1024 × 1024 px; se recomiendan 256–512 px para imágenes dentro del texto.", gifTooLarge: "Elige un GIF de 5 MB o menos.","templates":"Comienza con una plantilla","restaurant":"Restaurante","shop":"Tienda","announcement":"Anuncio","restaurantMessage":"¡Hoy: dos pizzas por el precio de una! Visítanos.","shopMessage":"¡Ofertas de fin de semana! Descubre nuestros productos.","announcementMessage":"¡Tenemos novedades! Pregunta por nuestros nuevos servicios.","title": "Mensaje visual", "help": "Combina texto, fotos, emojis y stickers animados. Arrastra los bloques para cambiar el orden.", "style": "Estilo:", "simple": "Simple", "promotion": "Promoción", "celebration": "Celebración", "TEXT": "Texto", "IMAGE": "Imagen", "EMOJI": "Emoji", "STICKER": "Sticker animado", "addText": "Agregar texto", "addImage": "Agregar imagen", "addEmoji": "Agregar emoji", "addSticker": "Agregar sticker animado", "alt": "Descripción de imagen (también se muestra en apps anteriores)", "placeholder": "Escribe tu mensaje", "reorder": "Arrastra para cambiar el orden", "before": "Mover antes", "after": "Mover después", "remove": "Eliminar elemento", "search": "Buscar", "party": "Celebración", "gift": "Regalo", "fire": "Fuego", "star": "Estrella", "heart": "Corazón", "arrow": "Flecha", "food": "Comida", "sports": "Deportes", "sale": "Oferta", "invalid": "Completa cada elemento. Usa un máximo de 24 elementos, 8 imágenes y 500 caracteres.", "sample": "¡Oferta especial! Visítanos hoy."},
  audience: {
    serviceGroup: "Grupo de servicio",
    addressAutocompleteHelp: "Expande un país para ver sus provincias/estados y municipios. Selecciona cualquier nivel.",
    noAddressResults: "No se encontraron ubicaciones.",
    userGroupPickerHelp: "Expande un grupo y elige una ubicación de servicio.",
    addAssignment: "Añadir asignación de ubicación",
    groupPickerHelp: "Expande un grupo para ver sus ubicaciones. Seleccionar un grupo también incluye sus descendientes.",
    expandGroup: "Expandir grupo",
    collapseGroup: "Contraer grupo",
    segmentation: "Segmentación",
    segmentationGroups: "Grupos",
    layoutInheritance: "Hereda el diseño del grupo padre más cercano, o el de la instalación si ningún grupo lo especifica.",
    expandAll: "Expandir todo",
    collapseAll: "Contraer todo",
    addChild: "Añadir ubicación hija",
    members: "Usuarios",
    actions: "Acciones",
    noGroups: "No se encontraron grupos ni ubicaciones.",
    close: "Cerrar",
    addUsersToGroup: "Agregar usuarios al grupo {name}",
    selectDisplayTarget: "Selecciona al menos una ubicación geográfica o grupo de servicio.",
    displayTargetHelp: "Si seleccionas ambos, los usuarios deben coincidir con la ubicación geográfica y el grupo de servicio. Se mantienen las exclusiones de la campaña.",
    addExisting: "Agregar usuario existente",
    memberName: "Nombre",
    memberUsername: "Usuario",
    memberGroup: "Grupo de servicio",
    addSelectedUsers: "Agregar usuarios seleccionados",
    membersPartialFailure: "No se pudieron agregar algunos usuarios. Las adiciones exitosas se guardaron; reintenta con la selección restante.",
    newUser: "Agregar usuario nuevo",
    includeChildren: "Incluir ubicaciones hijas",
    searchMembers: "Buscar usuarios",
    membersHelp: "Incluye asignaciones directas, por dispositivo y programadas, incluso las vencidas.",
    noMembers: "No se encontraron usuarios.",
    previous: "Anterior",
    next: "Siguiente",
    memberAdded: "Usuario añadido correctamente",
    addMemberHelp: "Añade una asignación para toda la cuenta a este grupo. Se conservan las ubicaciones y distribuidores existentes; resuelva los conflictos en el editor del usuario.",

    delete: "Eliminar",
    deleteNode: "Eliminar ubicación",
    deleteConfirmation: "¿Eliminar «{name}»? Solo se permite si no quedan asociaciones.",
    deleted: "Eliminado correctamente",

    editNode: "Editar grupo o ubicación", retry: "Reintentar",
  "title": "Gestión de audiencias",
  "groups": "Grupos y ubicaciones",
  "partner": "Distribuidor / programa",
  "location": "Ubicación de servicio",
  "inherit": "Heredar valores predeterminados",
  "none": "Ninguno",
  "add": "Agregar",
  "remove": "Quitar",
  "save": "Guardar",
  "edit": "Editar",
  "cancel": "Cancelar",
  "name": "Nombre",
  "type": "Tipo",
  "parent": "Ubicación superior",
  "layout": "Diseño de la aplicación",
  "assignment": "Asignaciones de servicio",
  "device": "Identificador del dispositivo (opcional)",
  "deviceHelp": "Déjalo vacío para la asignación de la cuenta. Para una instalación fija, usa el identificador que aparece en las sesiones del usuario.",
  "starts": "Inicio (fecha y hora, opcional)",
  "ends": "Fin (fecha y hora, opcional)",
  "assignmentHelp": "Selecciona un grupo o unidad. Las asignaciones incluyen los grupos superiores y caducan al llegar su fecha de fin.",
  "disabled": "La gestión de audiencias está desactivada en esta instalación.",
  "loadError": "No se pudo cargar la configuración de audiencias.",
  "loading": "Cargando…",
  "saved": "Guardado",
  "newNode": "Nuevo grupo o ubicación",
  "include": "Incluir",
  "exclude": "Excluir",
  "includeLocations": "Ubicaciones geográficas incluidas",
  "excludeLocations": "Ubicaciones geográficas excluidas",
  "geography": "Ubicación geográfica",
  "country": "País",
  "area": "Provincia / estado",
  "locality": "Municipio / ciudad",
  "selectCountry": "Selecciona un país primero",
  "selectArea": "Selecciona una provincia primero",
  "search": "Buscar",
  "emptyLocations": "No hay ubicaciones seleccionadas",
  "duplicate": "La ubicación ya está agregada",
  "clear": "Quitar todas",
  "rulesHelp": "Debe coincidir cada dimensión de inclusión configurada. Cualquier exclusión prevalece. Los datos desconocidos no omiten las exclusiones.",
  "allGeographicLocations": "Todas las ubicaciones geográficas",
  "allServiceGroups": "Todos los grupos de servicio",
  "noExclusions": "Ninguno",
  "includeGroupsHelp": "Sin selección se incluyen todos los grupos de servicio.",
  "excludeGroupsHelp": "Las exclusiones prevalecen sobre las inclusiones.",
  "includeHelp": "Sin selección se incluyen todas las ubicaciones.",
  "excludeHelp": "Las exclusiones prevalecen sobre las inclusiones.",
  "hiddenRules": "Los controles de audiencia están desactivados. Se conservan las restricciones existentes.",
  "includeGroups": "Grupos de servicio incluidos",
  "excludeGroups": "Grupos de servicio excluidos",
  "inherited": "Configuración heredada",
  "locationInheritance": "Deja la geografía vacía para heredarla de la ubicación de servicio.",
  "structureHelp": "Los grupos y unidades son independientes de la geografía. El tipo y la ubicación superior no se pueden cambiar después de crear.",
  "types": {
    "COMPLEX": "Complejo",
    "HOTEL": "Hotel",
    "RESIDENTIAL": "Grupo residencial",
    "BUILDING": "Edificio",
    "FLOOR": "Piso",
    "ROOM": "Habitación",
    "HOUSE": "Casa",
    "APARTMENT": "Apartamento",
    "PARTNER": "Revendedor / distribuidor",
    "PROGRAM": "Programa de distribución"
  }
},
  channelScraping: {
    blockAds: "Bloquear anuncios",
    blockAdsHelp: "Bloquea anuncios que pueden impedir que el reproductor inicie. Desactiva esta opción si el reproductor necesita scripts publicitarios.",
  },
  adCreatives: {
    imageRecommendations: {"title": "Recomendaciones de imagen", "bannerTitle": "Banner — TV en vivo, VOD, Inicio y Radio", "bannerSize": "1920 × 160 px; en 4K: 3840 × 320 px. Para superposiciones, usa una altura de 8–10% de la pantalla y evita cubrir subtítulos o marcadores.", "landscapeTitle": "Horizontal 16:9 — Pantalla de Inicio y Radio", "landscapeSize": "1920 × 1080 px (Full HD); en 4K: 3840 × 2160 px. Recomendado para diapositivas de Inicio y el área central de Radio, tanto en vista previa como en pantalla completa.", "safeArea": "Deja al menos 40 px de margen para textos y logos. Mantén la información importante lejos de las franjas superior e inferior, donde pueden aparecer controles o mensajes.", "formats": "JPG para fotografías; PNG para gráficos o transparencia.", "separate": "Crea versiones separadas si necesitas un banner y una imagen 16:9 para distintas ubicaciones."},
    locationHelpLabel: "Ayuda",
    locationHelp: {"live": "Muestra los creativos durante la reproducción de canales en vivo. Puedes incluir o excluir canales. Los videos requieren horarios recurrentes.", "vod": "Muestra los creativos al reproducir películas y series. Los videos se muestran antes del contenido; las imágenes y los textos se superponen durante la reproducción.", "home": "Muestra imágenes y videos como diapositivas de fondo, y textos o noticias como mensajes en la Pantalla de Inicio. Los mensajes se reproducen después de las alertas y se actualizan al terminar cada ronda."},
    campaignPreview: "Resumen de campaña",
    preview: "Vista previa",
    unnamedCampaign: "Nueva campaña",
    noLocations: "Selecciona dónde se mostrará la campaña.",
    schedule: "Programación",
    untilDisabled: "Hasta desactivar",
    recurringSchedules: "Horarios recurrentes",
    priority: "Prioridad",
    dailyLimit: "Impresiones por usuario al día",
    unlimited: "Sin límite",

    missingLocations: "Agrega o asigna un creativo para cada ubicación: faltan",
    enableLocation: "Activa esta ubicación en Configuración de campaña.",
    rename: "Cambiar nombre",
    empty: "Agrega un creativo y selecciona su formato para comenzar.",
    location: "Ubicación de creativo",
    formats: { VIDEO: "Video", BANNER: "Imagen", TEXT: "Texto desplazable", NEWS_TICKER: "News ticker" },
    homeMedia: "Usa la imagen o video de este creativo. Tamaño recomendado para inicio: 1920 × 1080. Agrega otro creativo si la reproducción necesita otra proporción.",
    settings: "Configuración de campaña",
    targeting: "Esta campaña se mostrará en",
    "title": "Creativos",
    "help": "Cada creativo tiene su propio contenido y ubicaciones. Todos comparten la programación, audiencia, prioridad y límites de la campaña.",
    "add": "Agregar creativo",
    "creative": "Creativo",
    "name": "Nombre del creativo",
    "enabled": "Habilitado",
    "disabled": "Deshabilitado",
    "duplicate": "Duplicar",
    "remove": "Eliminar",
    "earlier": "Mover antes",
    "later": "Mover después",
    "copy": "copia",
    "review": "Revisa el creativo",
    "format": "Formato del creativo",
    "choose": "Selecciona un creativo para previsualizar",
    "destinations": "Ubicaciones",
    "live": "TV en vivo",
    "vod": "VOD",
    "radio": "Radio",
    "home": "Pantalla de Inicio",
    "all": "Rotación automática"
},
  homeCampaign: {
    "title": "Pantalla de Inicio",
    "enabled": "Mostrar en inicio",
    "media": "Imagen/video para inicio",
    "help": "Selecciona un archivo horizontal independiente (recomendado 1920 × 1080). La navegación permanece visible. Los banners de reproducción no se redimensionan automáticamente.",
    "duration": "Duración máxima (segundos)",
    "cadence": "Elementos normales entre anuncios",
    "muted": "Silenciar video en inicio",
    "kids": "Permitir en modo infantil",
    "sports": "Permitir en modo deportes",
    "fontFamily": "Familia de fuente",
    "fontColor": "Color de fuente",
    "fontSize": "Tamaño de fuente (sp)",
    "preview": "Vista previa de inicio",
    "tickerHelp": "Usa el texto o la fuente de noticias y la tipografía de este creativo. No aplica los gráficos ni los fondos de reproducción. Primero se muestran las alertas y luego todos los creativos elegibles de texto/noticias para inicio. Cada mensaje termina antes del siguiente; la lista se actualiza después de cada ronda.",
    "invalidMedia": "Selecciona una URL HTTP(S) válida para el archivo de inicio.",
    "invalidSettings": "Revisa la duración y frecuencia de inicio.",
    "slide": "Diapositiva de inicio",
    "ticker": "Franja de inicio",
    "navigation": "Navegación de inicio",
    "reuse": "Usar archivo de reproducción",
    "off": "No se muestra en inicio"
},
  iptvProxy: {
    route: 'Ruta de solicitudes',
    proxy: 'Servidor de streams',
    direct: 'Servidor API',
    enabled: 'Consultar desde el servidor de streams',
    help: 'Usar el relay configurado para los detalles y listas del proveedor, incluida la automatización de canales.',
  },
  imageUpload: {
    preview: 'Vista previa de imagen',
    openPreview: 'Abrir vista previa de imagen',
  },
  radioCampaign: {
    "title": "Radio",
    "enabled": "Mostrar en radio",
    "disabled": "No se muestra en radio",
    "mode": "Modo de pantalla de radio",
    "BOTH": "Vista previa y pantalla completa",
    "BROWSING": "Solo vista previa",
    "FULLSCREEN": "Solo pantalla completa",
    "include": "Incluir emisoras",
    "exclude": "Excluir emisoras",
    "all": "Todas las emisoras",
    "none": "Ninguna",
    "select": "Seleccionar emisoras",
    "targeting": "Deja las emisoras incluidas vacías para seleccionar todas. Las exclusiones tienen prioridad.",
    "placement": "Los banners y textos se muestran debajo de la vista previa o en la zona inferior de pantalla completa. Las noticias aparecen en el borde inferior. Radio usa posición inferior y escala normal; la posición de TV/VOD se configura por separado.",
    "video": "Los anuncios de video no están disponibles en radio.",
    "loading": "Cargando emisoras…",
    "loadError": "No se pudieron cargar las emisoras. Se conservan las selecciones existentes.",
    "retry": "Reintentar",
    "overlap": "Una emisora no puede estar incluida y excluida al mismo tiempo.",
    "location": "La segmentación geográfica utiliza la ubicación del oyente, no el país de la emisora."
},
  // Form validation messages
  validation: {
    required: 'Este campo es obligatorio',
    email: 'Ingrese un correo electrónico válido',
    minLength: (min: number) => `Debe tener al menos ${min} caracteres`,
    maxLength: (max: number) => `Debe tener menos de ${max} caracteres`,
    passwordRequirements: 'La contraseña debe contener al menos una letra minúscula, una mayúscula y un número',
    usernameFormat: 'El nombre de usuario solo puede contener letras, números y guiones bajos',
    phoneFormat: 'Ingrese un número de teléfono válido',
    urlFormat: 'Ingrese una URL válida',
  },

  // Form fields
  form: {
    username: 'Usuario',
    fullName: 'Nombre Completo',
    email: 'Correo Electrónico',
    phoneNumber: 'Número de Teléfono',
    password: 'Contraseña',
    role: 'Rol',
  },

  // Form placeholders
  placeholders: {
    username: 'Ingrese el nombre de usuario',
    fullName: 'Ingrese el nombre completo',
    email: 'Ingrese el correo electrónico',
    phoneNumber: 'Ingrese el número de teléfono',
    password: 'Ingrese la contraseña',
    selectRole: 'Seleccione un rol',
  },

  // Helper texts
  helpers: {
    password: 'Mínimo 4 caracteres',
  },

  // Buttons
  buttons: {
    create: 'Crear Usuario',
    creating: 'Creando Usuario...',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    signIn: 'Iniciar Sesión',
    signingIn: 'Iniciando Sesión...',
    addLink: 'Agregar Link',
    edit: 'Editar',
    delete: 'Eliminar',
    retry: 'Reintentar',
  },

  // Roles
  roles: {
    User: 'Usuario',
    Moderator: 'Moderador',
    Admin: 'Administrador',
  },

  // Form titles and descriptions
  createUser: {
    title: 'Nuevo Usuario',
    description: 'Complete los datos para crear un nuevo usuario en el sistema.',
  },

  // Authentication
  auth: {
    login: {
      title: 'Iniciar Sesión',
      appTitle: '',
      appSubtitle: 'Panel de Administración',
      loginFailed: 'Error al iniciar sesión.',
      defaultAdmin: 'Cuenta de Administrador por Defecto:',
      unexpectedError: 'Ocurrió un error inesperado. Por favor, intenta de nuevo.',
    },
    placeholders: {
      username: 'Ingresa tu nombre de usuario',
      password: 'Ingresa tu contraseña',
    },
  },

  // Error messages
  errors: {
    createUserFailed: 'Error al crear el usuario',
    createCategoryFailed: 'Error al crear la categoría',
    updateCategoryFailed: 'Error al actualizar la categoría',
    deleteCategoryFailed: 'Error al eliminar la categoría',
    unexpectedError: 'Ocurrió un error inesperado',
    loadingError: 'Error al cargar los datos',
    // API errors
    networkError: 'Error de conexión. Por favor revisa tu conexión e inténtalo de nuevo.',
    serverError: 'Error del servidor. Por favor inténtalo de nuevo más tarde.',
    authenticationExpired: 'Tu sesión ha expirado. Por favor inicia sesión de nuevo.',
  },

  //users
  users: {
    registration: 'Registro',
    by: 'Por',
    createdBy: 'Creado por',
    title: 'Gestión de Usuarios',
    listTitle: 'Usuarios',
    messages: {
      deleted: "Usuario eliminado exitosamente",
      confirmDelete: "¿Está seguro de que desea eliminar este usuario?",
    },
    placeholders: {
      search: 'Buscar usuarios...',
      fullName: 'Ingrese el nombre completo',
      username: 'Ingrese el nombre de usuario',
      email: 'Ingrese el correo electrónico',
      phoneNumber: 'Ingrese el número de teléfono',
    },
    validation: {
      roleRequired: 'Por favor seleccione un rol',
    }
  },

  // Categories
  categories: {
    title: 'Gestión de Categorías',
    description: 'Administra las categorías del sistema para películas y series y más.',
    createTitle: 'Crear Nueva Categoría',
    createDescription: 'Complete los datos para crear una nueva categoría.',
    editTitle: 'Editar Categoría',
    editDescription: 'Modifica los datos de la categoría.',
    listTitle: 'Lista de Categorías',

    // Fields
    fields: {
      description: 'Descripción',
      englishDescription: 'Descripción en Inglés',
      type: 'Tipo',
      displayOrder: 'Posición',
      imageUrl: 'URL de Imagen',
      active: 'Activo',
      createdDate: 'Creado',
      updatedDate: 'Modificado',
      adultContent: 'Contenido para Adultos',
      sportsContent: 'Contenido Deportivo',
    },

    // Placeholders
    placeholders: {
      description: 'Ingrese la descripción',
      englishDescription: 'Ingrese la descripción en inglés',
      selectType: 'Seleccione un tipo',
      displayOrder: 'Ingrese la posición',
      imageUrl: 'Ingrese la URL de la imagen',
      search: 'Buscar categorías...',
    },

    // Types
    types: {
      MOVIE: 'Película',
      TV_SHOW: 'Serie',
      DOCUMENTARY: 'Documental',
      SPORTS: 'Deportes',
      MUSIC: 'Música',
      TV_CHANNEL: 'Canal de TV',
      RADIO_STATION: 'Estación de Radio',
    },

    // Actions
    actions: {
      create: 'Crear Categoría',
      creating: 'Creando Categoría...',
      edit: 'Editar',
      delete: 'Eliminar',
      activate: 'Activar',
      deactivate: 'Desactivar',
      view: 'Ver Detalles',
    },

    // Messages
    messages: {
      created: 'Categoría creada exitosamente',
      updated: 'Categoría actualizada exitosamente',
      deleted: 'Categoría eliminada exitosamente',
      statusUpdated: 'Estado de la categoría actualizado',
      confirmDelete: '¿Está seguro de que desea eliminar esta categoría?',
      noResults: 'No se encontraron categorías.',
      noData: 'No hay categorías disponibles.',
    },
  },

  // TV Guide
  tvGuide: {
    title: 'Guía de Canales de TV',
    description: 'Administra las guías de canales de televisión del sistema.',
    createTitle: 'Crear Nueva Guía de TV',
    createDescription: 'Complete los datos para crear una nueva guía de canales de TV.',
    editTitle: 'Editar Guía de TV',
    editDescription: 'Modifica los datos de la guía de canales de TV.',
    listTitle: 'Guías de TV',

    // Fields
    fields: {
      title: 'Título',
      url: 'URL',
      active: 'Activo',
      gzip: 'Compresión GZIP',
      lastSyncDate: 'Última sincronización',
      lastSyncStatus: 'Estado de sincronización',
      syncErrorMessage: 'Error de sincronización',
      createdDate: 'Creado',
      updatedDate: 'Modificado',
    },

    // Placeholders
    placeholders: {
      title: 'Ingrese el título de la guía',
      url: 'Ingrese la URL de la guía',
      search: 'Buscar guías de TV...',
    },

    // Actions
    actions: {
      create: 'Crear Guía de TV',
      creating: 'Creando Guía de TV...',
      edit: 'Editar',
      sync: 'Sincronizar',
      delete: 'Eliminar',
      activate: 'Activar',
      deactivate: 'Desactivar',
      view: 'Ver Detalles',
    },

    // Messages
    messages: {
      created: 'Guía de TV creada exitosamente',
      updated: 'Guía de TV actualizada exitosamente',
      deleted: 'Guía de TV eliminada exitosamente',
      statusUpdated: 'Estado de la guía de TV actualizado',
      confirmDelete: '¿Está seguro de que desea eliminar esta guía de TV?',
      noResults: 'No se encontraron guías de TV.',
      noData: 'No hay guías de TV disponibles.',
    },

    // Validation
    validation: {
      titleRequired: 'El título es obligatorio',
      urlRequired: 'La URL es obligatoria',
      urlInvalid: 'Ingrese una URL válida',
    },
  },

  // TV Channels
  tvChannels: {
    title: 'Canales de TV',
    description: 'Administra los canales de televisión del sistema.',
    createTitle: 'Nuevo Canal de TV',
    createDescription: 'Complete los datos para crear un nuevo canal de televisión.',
    editTitle: 'Editar Canal de TV',
    editDescription: 'Modifica los datos del canal de televisión.',
    listTitle: 'Canales de TV',

    // Fields
    fields: {
      channelNumber: '#',
      country: 'País',
      title: 'Título',
      tvGuide: 'Guía de TV',
      category: 'Categoría',
      categories: 'Categorías',
      epgId: 'EPG ID',
      imageUrl: 'Imagen',
      active: 'Activo',
      play: 'Reproducir',
      adultContent: 'Para Adultos',
      kidsContent: 'Para Niños',
      urlType: 'Tipo de URL',
      url: 'Enlace (URL)',
      createdDate: 'Creado',
      updatedDate: 'Modificado',
      logo: 'Logo'
    },

    // Placeholders
    placeholders: {
      channelNumber: 'Ingrese el número de canal',
      country: 'Seleccione un país',
      title: 'Ingrese el título del canal',
      tvGuide: 'Seleccione una guía de TV',
      category: 'Seleccione una categoría',
      categories: 'Seleccione categorías',
      epgId: 'Ingrese el EPG ID',
      imageUrl: 'Ingrese la URL de la imagen',
      url: 'Ingrese la URL o número',
      search: 'Buscar por número o nombre...',
    },

    // URL Types
    urlTypes: {
      internal: 'Interno',
      external: 'Externo',
    },

    // Actions
    actions: {
      create: 'Crear Canal de TV',
      creating: 'Creando Canal de TV...',
      edit: 'Editar',
      delete: 'Eliminar',
      activate: 'Activar',
      deactivate: 'Desactivar',
      play: 'Reproducir',
      view: 'Ver Detalles',
    },

    // Messages
    messages: {
      created: 'Canal de TV creado exitosamente',
      updated: 'Canal de TV actualizado exitosamente',
      deleted: 'Canal de TV eliminado exitosamente',
      statusUpdated: 'Estado del canal de TV actualizado',
      confirmDelete: '¿Está seguro de que desea eliminar este canal de TV?',
      noResults: 'No se encontraron canales de TV.',
      noData: 'No hay canales de TV disponibles.',
      imagePreview: 'Vista previa de la imagen',
      imageError: 'Error al cargar la imagen',
      resolvingStream: 'Resolviendo URL del stream...',
      rtspInlineNotSupported: 'Los streams RTSP no son compatibles con reproducción en navegador.',
      noPlayableStream: 'No se encontró una URL de stream reproducible.',
    },

    // Base URL Configuration
    baseUrl: {
      title: 'URL Base de Canales',
      edit: 'Editar',
      save: 'Guardar',
      saving: 'Guardando...',
      cancel: 'Cancelar',
      loading: 'Cargando...',
      placeholder: 'Ingrese la URL base de canales',
      notSet: 'No configurada',
      saveSuccess: 'URL base de canales actualizada exitosamente',
      saveError: 'Error al actualizar la URL base de canales'
    },

    // Validation
    validation: {
      channelNumberRequired: 'El número de canal es obligatorio',
      channelNumberMin: 'El número de canal debe ser mayor o igual a 0',
      countryRequired: 'El país es obligatorio',
      titleRequired: 'El título es obligatorio',
      tvGuideRequired: 'La guía de TV es obligatoria',
      categoryRequired: 'La categoría es obligatoria',
      epgIdMax: 'El EPG ID debe tener máximo 1000 caracteres',
      imageUrlInvalid: 'Ingrese una URL de imagen válida',
      urlRequired: 'La URL es obligatoria',
      urlInvalidExternal: 'Ingrese una URL externa válida',
      urlInvalidInternal: 'Ingrese un número válido para URL interna',
    },
  },

  countries: {
    title: 'Países',
    description: 'Administra el catálogo de países utilizados en la plataforma.',
    createTitle: 'Crear País',
    createDescription: 'Ingresa la información para registrar un nuevo país.',
    editTitle: 'Editar País',
    editDescription: 'Actualiza la información del país seleccionado.',
    listTitle: 'Listado de Países',

    fields: {
      nameEnglish: 'Nombre en Inglés',
      name: 'Nombre',
      flag: 'Bandera',
      displayOrder: 'Posición',
      createdDate: 'Creado',
      updatedDate: 'Actualizado',
    },

    placeholders: {
      nameEnglish: 'Ingrese el nombre en inglés',
      name: 'Ingrese el nombre del país',
      flag: 'Ingrese un emoji o URL de imagen',
      flagPreview: 'Vista previa de bandera',
      flagNotSet: 'Bandera no configurada',
      displayOrder: 'Ingrese el orden',
      displayOrderNotSet: 'Sin definir',
      search: 'Buscar países...',
    },

    actions: {
      create: 'Crear País',
      creating: 'Guardando país...',
      update: 'Actualizar País',
      edit: 'Editar',
      delete: 'Eliminar',
    },

    messages: {
      created: 'País creado exitosamente',
      updated: 'País actualizado exitosamente',
      deleted: 'País eliminado exitosamente',
      confirmDelete: '¿Está seguro de eliminar este país?',
      noData: 'No hay países registrados. Crea el primero.',
    },

    validation: {
      nameEnglishRequired: 'El nombre en inglés es obligatorio',
      nameRequired: 'El nombre es obligatorio',
      nameMax: 'El nombre debe tener máximo 150 caracteres',
      displayOrderNumber: 'El orden debe ser un número entero',
      displayOrderMin: 'El orden debe ser mayor o igual a 0',
    },
  },

  // Sports
  sports: {
    title: 'Gestión de Deportes',
    description: 'Gestiona el contenido deportivo del sistema.',
    createTitle: 'Nuevo Deporte',
    createDescription: 'Completa los detalles para crear nuevo contenido deportivo.',
    editTitle: 'Editar Deporte',
    editDescription: 'Modifica los detalles del contenido deportivo.',
    listTitle: 'Deportes',

    // Fields
    fields: {
      title: 'Título',
      year: 'Año',
      releaseDate: 'Fecha de Lanzamiento',
      durationMinutes: 'Duración (Minutos)',
      spanishSynopsis: 'Sinopsis en Español',
      englishSynopsis: 'Sinopsis en Inglés',
      genres: 'Géneros',
      category: 'Categoría',
      coverImage: 'Imagen de Portada',
      backgroundImage: 'Imagen de Fondo',
      trailer: 'URL del Trailer',
      reference: 'Referencia',
      active: 'Activo',
      adultContent: 'Para Adultos',
      monoAudio: 'Audio Mono',
      englishOnly: 'Solo Inglés',
      kidsContent: 'Para Niños',
      createdDate: 'Creado',
      updatedDate: 'Modificado',
    },

    // Placeholders
    placeholders: {
      title: 'Ingresa el título del deporte',
      year: 'Ingresa el año',
      releaseDate: 'Selecciona fecha de lanzamiento',
      durationMinutes: 'Ingresa la duración en minutos',
      spanishSynopsis: 'Ingresa la sinopsis en español',
      englishSynopsis: 'Ingresa la sinopsis en inglés',
      category: 'Selecciona una categoría',
      coverImage: 'Ingresa URL de imagen de portada',
      backgroundImage: 'Ingresa URL de imagen de fondo',
      trailer: 'Ingresa URL del trailer',
      reference: 'Ingresa referencia',
      search: 'Buscar deportes...',
    },

    // Genres
    genres: {
      AEROBICO: 'Aeróbico',
      AERODROMO: 'Aeródromo',
      AJEDREZ: 'Ajedrez',
      ALA_DELTA: 'Ala Delta',
      ALPINISMO: 'Alpinismo',
      ARTES_MARCIALES: 'Artes Marciales',
      ATLETISMO: 'Atletismo',
      AUTOMOVILISMO: 'Automovilismo',
      BADMINTON: 'Bádminton',
      BALONCESTO: 'Baloncesto',
      BEISBOL: 'Béisbol',
      BOXEO: 'Boxeo',
      CICLISMO: 'Ciclismo',
      ESCALADA: 'Escalada',
      ESGRIMA: 'Esgrima',
      ESQUI: 'Esquí',
      FUTBOL: 'Fútbol',
      FUTBOL_AMERICANO: 'Fútbol Americano',
      GIMNASIA: 'Gimnasia',
      GOLF: 'Golf',
      HOCKEY: 'Hockey',
      LUCHA_LIBRE: 'Lucha Libre',
      NATACION: 'Natación',
      MOTOCICLISMO: 'Motociclismo',
      PARACAIDISMO: 'Paracaidismo',
      RUGBY: 'Rugby',
      SURF: 'Surf',
      TENIS: 'Tenis',
      VOLLEYBALL: 'Voleibol',
      WATERPOLO: 'Waterpolo',
    },

    // Actions
    actions: {
      create: 'Crear Deporte',
      creating: 'Creando Deporte...',
      edit: 'Editar',
      delete: 'Eliminar',
      activate: 'Activar',
      deactivate: 'Desactivar',
      view: 'Ver Detalles',
      addLink: 'Agregar Enlace',
    },

    // Messages
    messages: {
      created: 'Deporte creado exitosamente',
      updated: 'Deporte actualizado exitosamente',
      deleted: 'Deporte eliminado exitosamente',
      statusUpdated: 'Estado del deporte actualizado',
      confirmDelete: '¿Estás seguro que deseas eliminar este deporte?',
      noResults: 'No se encontraron deportes.',
      noData: 'No hay deportes disponibles.',
      imagePreview: 'Vista previa de imagen',
      imageError: 'Error al cargar imagen',
      linkAdded: 'Enlace agregado exitosamente',
      linkUpdated: 'Enlace actualizado exitosamente',
      linkDeleted: 'Enlace eliminado exitosamente',
    },

    // Validation
    validation: {
      titleRequired: 'El título es requerido',
      titleMinLength: 'El título debe tener al menos 3 caracteres',
      titleMaxLength: 'El título no puede exceder 200 caracteres',
      yearRequired: 'El año es requerido',
      yearMin: 'El año debe ser al menos 1900',
      yearMax: 'El año no puede exceder 2100',
      durationRequired: 'La duración es requerida',
      durationMin: 'La duración debe ser al menos 1 minuto',
      durationMax: 'La duración no puede exceder 999 minutos',
      spanishSynopsisMax: 'La sinopsis en español no puede exceder 10000 caracteres',
      englishSynopsisMax: 'La sinopsis en inglés no puede exceder 10000 caracteres',
      categoryRequired: 'La categoría es requerida',
      coverImageInvalid: 'Ingresa una URL válida para la imagen de portada',
      backgroundImageInvalid: 'Ingresa una URL válida para la imagen de fondo',
      trailerInvalid: 'Ingresa una URL válida para el trailer',
      referenceMax: 'La referencia no puede exceder 100 caracteres',
    },
  },
  // Links
  links: {
    title: 'Links',
    quality: 'Calidad',
    url: 'URL',
    audioLanguage: 'Idioma de Audio',
    subtitleLanguage: 'Idioma de Subtítulos',
    status: 'Estado',
    actions: 'Acciones',
    addLink: 'Agregar Link',
    editLink: 'Editar Link',
    deleteLink: 'Eliminar Link',
    noLinks: 'No hay links disponibles',
    active: 'Activo',
    inactive: 'Inactivo',
    activate: 'Activar',
    deactivate: 'Desactivar',
    required: 'Debe agregar al menos un link',
  },

  mediaAssets: {
    title: 'Medios de Fondo y Trailer',
    backgroundImageUrl: 'URL de Imagen de Fondo',
    backgroundImagePlaceholder: 'https://ejemplo.com/fondo.jpg',
    trailerUrl: 'URL del Trailer',
    trailerUrlPlaceholder: 'https://youtube.com/watch?v=...',
    backgroundPreview: 'Vista Previa del Fondo',
    trailerPreview: 'Vista Previa del Trailer',
    failedToLoad: 'Error al cargar',
    loadingBackgroundImage: 'Cargando imagen de fondo',
    backgroundImageFailedToLoad: 'Error al cargar la imagen de fondo',
    playVideoInline: 'Reproducir video en línea',
    openTrailerInNewTab: 'Abrir trailer en nueva pestaña',
    clickToPlay: 'Clic para reproducir',
    clickToOpen: 'Clic para abrir',
    youtubeVideo: 'Video de YouTube',
    vimeoVideo: 'Video de Vimeo',
    videoTrailer: 'Trailer de Video',
    minimizeVideo: 'Minimizar video',
    maximizeVideo: 'Maximizar video',
    openVideoInNewTab: 'Abrir video en nueva pestaña',
    closeVideoPlayer: 'Cerrar reproductor de video',
    videoFormatNotSupported: 'Formato de video no compatible para reproducción en línea',
    openInNewTab: 'Abrir en nueva pestaña',
    videoNotSupported: 'Tu navegador no soporta la etiqueta de video.',
    emptyStateMessage: 'Agrega URLs de imagen de fondo y trailer para ver vistas previas',
    videoContent: 'contenido de video'
  },

  movies: {
    genres: {
      ACTION: 'Acción',
      ADVENTURE: 'Aventura',
      ANIMATION: 'Animación',
      BIOGRAPHY: 'Biografía',
      COMEDY: 'Comedia',
      CRIME: 'Crimen',
      DOCUMENTARY: 'Documental',
      DRAMA: 'Drama',
      FAMILY: 'Familiar',
      FANTASY: 'Fantasía',
      HISTORY: 'Historia',
      HORROR: 'Terror',
      MUSIC: 'Música',
      MYSTERY: 'Misterio',
      ROMANCE: 'Romance',
      SCI_FI: 'Ciencia Ficción',
      TV_MOVIE: 'Película de TV',
      THRILLER: 'Suspenso',
      WAR: 'Guerra',
      WESTERN: 'Western',
    }
  },

  documentaries: {
    genres: {
      ARTE_Y_MUSICA: "Arte y Música",
      BIOGRAFIA: 'Biografía',
      CIENCIA: 'Ciencia',
      COMEDIA: 'Comedia',
      CONSPIRACION: 'Conspiración',
      CRIMEN: 'Crimen',
      DROGAS: 'Drogas',
      ECONOMIA: 'Economía',
      FILOSOFIA: 'Filosofía',
      DEPORTES: 'Deportes',
      HISTORIA: 'Historia',
      MEDIO_AMBIENTAL: 'Medio Ambiental',
      MEDIOS: 'Medios',
      MILITAR_Y_GUERRA: 'Militar y Guerra',
      MISTERIO: 'Misterio',
      NATURALEZA: 'Naturaleza',
      POLITICA: 'Política',
      PSICOLOGIA: 'Psicología',
      RELIGION: 'Religión',
      SALUD: 'Salud',
      SEXUALIDAD: 'Sexualidad',
      SOCIEDAD: 'Sociedad',
      TECNOLOGIA: 'Tecnología',
      VIAJES: 'Viajes',
    }
  },

  // Issue Reports
  issueReports: {
    title: 'Reporte de Errores',
    listTitle: 'Reportes de Errores',
    searchPlaceholder: 'Títulos, Contenido, Tipo...',

    // Tabs
    tabs: {
      reportados: 'Abiertos',
      reparados: 'Cerrados',
      todos: 'Todos'
    },

    // Table columns
    columns: {
      number: '#',
      title: 'Título',
      content: 'Contenido',
      date: 'Fecha',
      type: 'Tipo',
      status: 'Estado',
      options: 'Opciones',
      occurrenceCount: 'Ocurrencias'
    },

    // Status labels
    status: {
      REPORTADO: 'Reportado',
      EN_PROGRESO: 'En Progreso',
      RESUELTO: 'Resuelto',
      CERRADO: 'Cerrado',
      RECHAZADO: 'Rechazado'
    },

    // Content types
    contentTypes: {
      TV: 'TV',
      MOVIE: 'Película',
      DOCUMENTARY: 'Documental',
      SPORT: 'Deportes',
      CONCERT: 'Concierto',
      EPISODE: 'Episodio',
      TRAILER: 'Trailer'
    },

    // Issue types
    issueTypes: {
      VIDEO: 'Video',
      AUDIO: 'Audio',
      SUBTITLES: 'Subtítulos',
      BUFFERING: 'Buffering',
      NOT_LOADING: 'No Carga',
      INCORRECT_INFO: 'Info Incorrecta',
      OTHER: 'Otro'
    },

    // Priority levels
    priorities: {
      LOW: 'Baja',
      MEDIUM: 'Media',
      HIGH: 'Alta',
      CRITICAL: 'Crítica'
    },

    // Actions
    actions: {
      view: 'Ver contenido',
      edit: 'Editar',
      markAsResolved: 'Marcar como resuelto',
      markAsInProgress: 'Marcar en progreso',
      markAsRejected: 'Marcar como rechazado',
      assign: 'Asignar',
      delete: 'Eliminar',
      changePriority: 'Cambiar prioridad'
    },

    // Messages
    messages: {
      noResults: 'No se encontraron reportes de errores.',
      noData: 'No hay reportes disponibles.',
      resolved: 'Reporte marcado como resuelto',
      inProgress: 'Reporte marcado como en progreso',
      rejected: 'Reporte marcado como rechazado',
      assigned: 'Reporte asignado exitosamente',
      deleted: 'Reporte eliminado exitosamente',
      priorityUpdated: 'Prioridad actualizada',
      confirmDelete: '¿Estás seguro que deseas eliminar este reporte?',
      confirmResolve: '¿Estás seguro que deseas marcar este reporte como resuelto?',
      confirmReject: '¿Estás seguro que deseas rechazar este reporte?'
    },

    // Total display
    total: 'TOTAL:'
  },
  common: {
    yes: 'Sí',
    no: 'No',
    active: 'Activo',
    inactive: 'Inactivo',
    actions: 'Acciones',
    episodes: 'Episodios',
    confirmationTitle: 'Confirmar acción',
    fields: {
      createdDate: 'Creado',
      updatedDate: 'Modificado',
    }
  },

  // Under Construction
  underConstruction: {
    title: 'Página en Construcción',
    subtitle: 'Estamos trabajando para traerte esta funcionalidad',
    description: 'Esta página está actualmente en desarrollo. Volveremos pronto con increíbles funciones nuevas.',
    features: {
      title: 'Próximamente:',
      items: [
        'Funcionalidades avanzadas',
        'Interfaz intuitiva y moderna',
        'Integración mejorada',
        'Experiencia de usuario optimizada'
      ]
    },
    backButton: 'Volver al inicio',
    contactInfo: 'Si tienes alguna pregunta, no dudes en contactarnos.',
    estimatedTime: 'Tiempo estimado: Próximamente'
  },

  radioStations: {
    title: 'Estaciones de Radio',
    description: 'Administra las estaciones de radio del sistema.',
    createTitle: 'Crear Nueva Estación de Radio',
    createDescription: 'Complete los datos para crear una nueva estación de radio.',
    editTitle: 'Editar Estación de Radio',
    editDescription: 'Modifica los datos de la estación de radio.',
    listTitle: 'Estaciones de Radio',

    // Fields
    fields: {
      stationName: 'Nombre de la Estación',
      stationLogo: 'Logo',
      country: 'País',
      categories: 'Categorías',
      genres: 'Géneros',
      streamUrl: 'URL del Stream',
      active: 'Activo',
      play: 'Reproducir',
      createdDate: 'Creado',
      updatedDate: 'Modificado',
      code: "Código",
    },

    // Placeholders
    placeholders: {
      stationName: 'Ingrese el nombre de la estación',
      stationLogo: 'Ingrese la URL del logo',
      country: 'Ingrese el país',
      categories: 'Seleccione categorías...',
      genres: 'Seleccione géneros...',
      streamUrl: 'Ingrese la URL del stream',
      search: 'Buscar estaciones de radio...',
      allCategories: 'Todas las categorías',
      allCountries: 'Todos los países',
    },

    // Actions
    actions: {
      create: 'Crear Estación de Radio',
      creating: 'Creando Estación de Radio...',
      edit: 'Editar',
      delete: 'Eliminar',
      activate: 'Activar',
      deactivate: 'Desactivar',
      play: 'Reproducir',
    },

    // Messages
    messages: {
      created: 'Estación de radio creada exitosamente',
      updated: 'Estación de radio actualizada exitosamente',
      deleted: 'Estación de radio eliminada exitosamente',
      statusUpdated: 'Estado actualizado exitosamente',
      confirmDelete: '¿Estás seguro que deseas eliminar esta estación de radio?',
      rtspInlineNotSupported: 'Los streams RTSP no son compatibles con reproducción en navegador.',
      noPlayableStream: 'No se encontró una URL de stream reproducible.',
    },

    // Validation
    validation: {
      stationNameRequired: 'El nombre de la estación es requerido',
      stationLogoInvalid: 'Por favor ingresa una URL válida para el logo',
      countryRequired: 'El país es requerido',
      genresRequired: 'Debe seleccionar al menos un género',
      streamUrlRequired: 'La URL del stream es requerida',
      streamUrlInvalid: 'Por favor ingresa una URL válida para el stream',
    },

    // Base URL Configuration
    baseUrl: {
      title: 'Configuración de URL Base para Estaciones de Radio',
      placeholder: 'https://example.com/radio',
      notSet: 'No configurado',
      edit: 'Editar',
      save: 'Guardar',
      saving: 'Guardando...',
      cancel: 'Cancelar',
      loading: 'Cargando...',
      saveSuccess: 'URL base actualizada exitosamente',
      saveError: 'Error al actualizar la URL base',
    },
  },
  tmdbSearch: {
    movieLabel: 'Buscar película en TMDB',
    tvShowLabel: 'Buscar serie en TMDB',
    placeholder: 'Ingrese un título o ID de TMDB',
    helper: 'Seleccione un resultado para cargar todos los detalles disponibles.',
    startTyping: 'Comience a escribir un título o ID de TMDB.',
    noResults: 'No se encontraron resultados en TMDB.',
    error: 'No se pudo completar la búsqueda en TMDB.',
    linkMovieLabel: 'Vincular esta película con TMDB',
    linkTvShowLabel: 'Vincular esta serie con TMDB',
    linkHelper: 'Se sugieren coincidencias primero por el ID de IMDb y luego por título y año. Seleccione el resultado correcto y guarde.',
    episodeLinkHelper: 'Seleccione la serie. Se vinculará con TMDB al cargar los detalles del episodio.',
    linkSuccess: 'Serie vinculada con TMDB.',
  },
  bulkEpisodes: {
    back: 'Volver a episodios',
    addEpisode: 'Agregar episodio',
    deleteEpisodes: 'Eliminar episodios',
    deleteTitle: 'Seleccionar episodios para eliminar',
    deleteDescription: 'Seleccione uno o más episodios de esta serie.',
    deleteSelected: 'Eliminar seleccionados',
    selectAll: 'Seleccionar todos los episodios',
    deleteConfirmation: '¿Está seguro de que desea eliminar los {count} episodios seleccionados? Esta acción no se puede deshacer.',
    deleted: '{count} episodios eliminados exitosamente',
    noneSelected: 'Seleccione al menos un episodio para continuar.',
    title: 'Importar episodios desde TMDB',
    generatedTitle: 'Crear episodios en masa',
    tmdbId: 'ID TMDB de la serie',
    tmdbLinkHelp: 'Seleccione la serie. Se vinculará con TMDB al cargar la vista previa.',
    seasonFrom: 'Temporada desde',
    seasonTo: 'Temporada hasta',
    episodeFrom: 'Episodio desde',
    episodeTo: 'Episodio hasta',
    quality: 'Calidad',
    linkTemplate: 'Plantilla del enlace',
    linkHelp: 'Use [ss]/[s] para temporada y [eee]/[ee]/[e] para episodio.',
    audioLanguages: 'Idiomas de audio',
    subtitleLanguages: 'Idiomas de subtítulos',
    englishTitleTemplate: 'Plantilla del título en inglés',
    spanishTitleTemplate: 'Plantilla del título en español',
    titleTemplateHelp: 'Use # donde debe aparecer el número del episodio.',
    defaultDuration: 'Minutos predeterminados',
    preview: 'Cargar vista previa',
    generatePreview: 'Generar vista previa',
    previewTitle: 'Episodios a crear',
    selected: '{selected} de {total} seleccionados',
    existing: '{count} episodios existentes omitidos',
    loadingImdbIds: 'Cargando IDs de IMDb...',
    imdbIdsPending: 'Espere a que termine la búsqueda de IDs de IMDb antes de crear los episodios.',
    imdbIdsError: 'No se pudieron cargar algunos IDs de IMDb. Cargue la vista previa nuevamente para reintentar.',
    create: 'Crear {count} episodios',
    created: '{count} episodios creados exitosamente',
    noEpisodes: 'No se encontraron episodios nuevos en el rango seleccionado.',
    previewError: 'No se pudo cargar la vista previa de episodios.',
    createError: 'No se pudieron crear los episodios.',
    invalidRange: 'El inicio de un rango no puede ser mayor que el final.',
    tooMany: 'Se pueden crear o importar hasta 200 episodios a la vez.',
    missingEpisodePlaceholder: 'La plantilla del enlace debe contener [e], [ee] o [eee].',
    missingSeasonPlaceholder: 'Una plantilla para varias temporadas debe contener [s] o [ss].',
    missingTitlePlaceholder: 'Ambas plantillas de título deben contener #.',
    invalidDuration: 'La duración debe estar entre 1 y 300 minutos.',
    incompleteEpisode: 'Cada episodio seleccionado necesita título, duración y URL del medio.',
    invalidLinks: 'Corrija o desmarque los episodios con URLs de medios inválidas antes de crearlos.',
    validationPending: 'Espere a que terminen las verificaciones de URLs antes de crear los episodios.',
    linkValidationError: 'No se pudo verificar la URL del medio.',
    checkingLink: 'Verificando URL del medio...',
    duplicatePosition: 'Dos episodios seleccionados usan la misma temporada y número de episodio.',
    include: 'Incluir episodio',
    season: 'Temporada',
    episode: 'Episodio',
    englishTitle: 'Título en inglés',
    spanishTitle: 'Título en español',
    airDate: 'Fecha de emisión',
    duration: 'Minutos',
    rating: 'Puntuación',
    url: 'URL del medio',
    details: 'Detalles',
    synopsis: 'Sinopsis',
    view: 'Ver',
    remove: 'Eliminar',
    detailsTitle: 'Detalles del episodio',
    coverImage: 'URL de portada',
    englishSynopsis: 'Sinopsis en inglés',
    spanishSynopsis: 'Sinopsis en español',
    done: 'Listo',
  },
  vodPlayer: {
    title: 'Reproductor de episodio',
    playEpisode: 'Reproducir episodio',
    movieTitle: 'Reproductor de película',
    playMovie: 'Reproducir película',
    playLink: 'Reproducir enlace',
    audioTrackUnavailable: 'No se encontró el idioma de audio solicitado en este archivo.',
    subtitleTrackUnavailable: 'No se encontró el idioma de subtítulos solicitado en este archivo.',
    loading: 'Preparando reproducción segura...',
    trackSettings: 'Configuración de audio y subtítulos',
    audioLanguage: 'Idioma de audio',
    subtitles: 'Subtítulos',
    off: 'Desactivados',
    notSpecified: 'No especificado',
    noMedia: 'No hay un enlace de video disponible para reproducir.',
    playbackError: 'No se pudo reproducir el video. Verifique que la URL esté disponible y sea compatible con este navegador.',
    play: 'Reproducir',
    pause: 'Pausar',
    seek: 'Posición de reproducción',
    volume: 'Volumen',
    fullscreen: 'Alternar pantalla completa',
    track: 'Pista',
  },
  contentProductivity: {
    title: 'Productividad de contenido',
    subtitle: 'Monitorea las cargas, el contenido completado y las metas del equipo.',
    overview: 'Resumen', goals: 'Metas y cuotas', exportCsv: 'Exportar CSV',
    thisWeek: 'Esta semana', lastWeek: 'Semana pasada', thisMonth: 'Este mes', lastMonth: 'Mes pasado',
    allContent: 'Todo el contenido', movies: 'Películas', episodes: 'Episodios',
    allContributors: 'Todos los colaboradores', contributor: 'Colaborador', contributors: 'Colaboradores',
    filesUploaded: 'Archivos cargados', contentCompleted: 'Contenido completado', uploadedSize: 'Tamaño cargado',
    dailyActivity: 'Actividad diaria de carga', files: 'Archivos', completed: 'Completados',
    valid: 'Válidos', invalid: 'Inválidos', size: 'Tamaño', type: 'Tipo de contenido',
    loading: 'Cargando…', noData: 'No se encontraron cargas para este período.',
    assignGoal: 'Asignar meta', editGoal: 'Editar meta', selectContributor: 'Selecciona un colaborador',
    from: 'Desde', to: 'Hasta', metric: 'Métrica', target: 'Objetivo', notes: 'Notas',
    frequency: 'Frecuencia', weekly: 'Semanal', monthly: 'Mensual',
    effectiveStart: 'Vigente desde', oneTimeLegacy: 'Una vez (anterior)',
    assign: 'Asignar', update: 'Actualizar', cancel: 'Cancelar', delete: 'Eliminar',
    targetUnits: 'unidades objetivo', noGoals: 'No hay metas que coincidan con este período.',
    quotaCreated: 'Meta asignada correctamente.', quotaUpdated: 'Meta actualizada correctamente.',
    quotaDeleted: 'Meta eliminada.', confirmDelete: '¿Eliminar esta meta?',
    saveError: 'No se pudo guardar la meta.', deleteError: 'No se pudo eliminar la meta.',
    all: 'Todos', searchContent: 'Buscar por título del contenido…',
    noDetails: 'No se encontró contenido con estos filtros.', inactive: 'Inactivo', view: 'Ver',
    previous: 'Anterior', next: 'Siguiente', results: '{count} resultados',
    completionPercentage: 'Cumplimiento'
  },
  applicationSettings: {
    sectionsUi: {
      "administration": "Administración",
      "android": "Android TV",
      "security": "Seguridad",
      "adminDescription": "Controla el portal administrativo. Guarda los cambios de cada sección por separado.",
      "androidDescription": "Valores globales para Android TV. Las preferencias del usuario y de cada variante de la app tienen prioridad.",
      "loading": "Cargando configuración…",
      "retry": "Reintentar",
      "unsaved": "Cambios sin guardar",
      "discard": "¿Descartar los cambios sin guardar de esta sección?",
      "recordId": "Registro de configuración",
      "defaultValue": "Predeterminado",
      "topCenter": "Arriba, centrado",
      "noTheme": "Tema predeterminado de la app",
      "missingAdmin": "La configuración administrativa todavía no está definida.",
      "sections": {
            "branding": "Marca y apariencia",
            "support": "Soporte y documentos legales",
            "modules": "Módulos de contenido",
            "tools": "Herramientas administrativas",
            "catalog": "Catálogo e indexación",
            "demos": "Cuentas de demostración",
            "appearance": "Inicio y tema",
            "navigation": "Navegación y reproducción",
            "movies": "Películas",
            "tvShows": "Series",
            "documentaries": "Documentales",
            "sports": "Deportes",
            "concerts": "Conciertos"
      },
      "fields": {
            "appName": "Nombre de la aplicación",
            "appSubtitle": "Subtítulo",
            "logoUrl": "URL del logo",
            "logoCompactUrl": "URL del logo compacto",
            "faviconUrl": "URL del favicon",
            "primaryColor": "Color primario",
            "secondaryColor": "Color secundario",
            "accentColor": "Color de acento",
            "fontFamily": "Familia tipográfica",
            "supportEmail": "Correo de soporte",
            "legalUrl": "URL de términos legales",
            "privacyUrl": "URL de privacidad",
            "categoriesEnabled": "Categorías",
            "tvChannelsEnabled": "Canales de TV",
            "tvGuideEnabled": "Guía de programación",
            "radioStationsEnabled": "Estaciones de radio",
            "moviesEnabled": "Películas",
            "tvShowsEnabled": "Series",
            "documentariesEnabled": "Documentales",
            "sportsEnabled": "Deportes",
            "concertsEnabled": "Conciertos",
            "iptvProvidersEnabled": "Proveedores IPTV",
            "flussonicServersEnabled": "Servidores Flussonic",
            "channelAutomationsEnabled": "Automatizaciones de canales",
            "channelScrapingEnabled": "Extracción de canales",
            "liveTvCountriesEnabled": "Países en la administración de TV",
            "radioCountriesEnabled": "Países en la administración de radio",
            "audienceManagementEnabled": "Gestión de audiencias",
            "adsEnabled": "Publicidad",
            "reportsEnabled": "Reportes",
            "premiereContentDays": "Período de estreno (días)",
            "recentContentDays": "Período de contenido reciente (días)",
            "indexOnSaveOrUpdate": "Actualizar el índice de búsqueda al guardar contenido",
            "maxDemoPerMonth": "Máximo de demostraciones por mes",
            "demoDays": "Duración de demostración (días)",
            "layout": "Diseño de inicio",
            "themeId": "Tema de Android TV",
            "homeSlidesDuration": "Duración de diapositivas de inicio (segundos; 0 = predeterminado)",
            "homeSlidesIndicatorPosition": "Posición del indicador de diapositivas",
            "changePasswordEnabled": "Permitir cambios de contraseña",
            "fullScreenEnterActsAsBack": "Usar Enter para salir de pantalla completa",
            "showChannelsOnCategoryFocus": "Mostrar canales al enfocar una categoría",
            "channelCategoriesExpanded": "Expandir categorías de canales",
            "categoryMenuOnPreviewMode": "Mostrar menú de categorías en vista previa",
            "numericButtonInCategoryMenuOnPreviewMode": "Mostrar botón numérico en el menú de vista previa",
            "mixCategoriesAndCountriesAlphabetically": "Mezclar categorías y países alfabéticamente",
            "removeCountryGrouping": "Eliminar agrupación por país",
            "moviesLastNYears": "Ventana de años de estreno (0 = todos)",
            "moviesShowPremiere": "Mostrar estrenos",
            "moviesShowRecentlyAdded": "Mostrar agregados recientemente",
            "tvShowsLastNYears": "Ventana de años de estreno (0 = todos)",
            "tvShowsShowPremiere": "Mostrar estrenos",
            "tvShowsShowRecentlyAdded": "Mostrar agregados recientemente",
            "documentariesLastNYears": "Ventana de años de estreno (0 = todos)",
            "documentariesShowPremiere": "Mostrar estrenos",
            "documentariesShowRecentlyAdded": "Mostrar agregados recientemente",
            "sportsLastNYears": "Ventana de años de estreno (0 = todos)",
            "sportsShowPremiere": "Mostrar estrenos",
            "sportsShowRecentlyAdded": "Mostrar agregados recientemente",
            "concertsLastNYears": "Ventana de años de estreno (0 = todos)",
            "concertsShowPremiere": "Mostrar estrenos",
            "concertsShowRecentlyAdded": "Mostrar agregados recientemente"
      }
},
    title: 'Configuración de la aplicación',
    layout: 'Diseño de inicio',
    save: 'Guardar configuración',
    saved: 'Configuración de la aplicación guardada.',
    loadError: 'No se pudo cargar la configuración de la aplicación.',
    saveError: 'No se pudo guardar la configuración de la aplicación.',
    seconds: 'segundos',
    minutes: 'minutos',
    requests: 'solicitudes',
    items: 'contenidos',
    vodHarvesting: {
      title: 'Protección contra extracción masiva de VOD',
      description: 'Detecta solicitudes de URLs de reproducción a velocidad de máquina entre todas las sesiones y dispositivos de una cuenta. Los cambios se aplican sin reiniciar la API.',
      detectionEnabled: 'Activar detección de extracción masiva',
      detectionHelp: 'Si está desactivada, las solicitudes no se evalúan ni se bloquean.',
      enforcementEnabled: 'Bloquear la extracción detectada',
      enforcementHelp: 'Mantén esta opción desactivada para modo observación: las solicitudes sospechosas se registran, pero se permiten.',
      thresholds: 'Umbrales de detección',
      moreInformation: 'Más información',
      shortWindow: 'Ventana corta de contenidos',
      shortWindowHelp: 'Período usado para contar cuántos contenidos VOD diferentes solicita la cuenta entre todas sus sesiones y dispositivos. Por ejemplo, 30 cuenta los contenidos distintos solicitados durante los últimos 30 segundos.',
      requestWindow: 'Ventana de frecuencia de solicitudes',
      requestWindowHelp: 'Período usado para el límite corto de frecuencia. Cada solicitud de URL de reproducción VOD cuenta, incluso si se repite el mismo contenido.',
      longWindow: 'Ventana larga de actividad',
      longWindowHelp: 'Período de observación más amplio usado por ambos límites de largo plazo. Permite detectar extracciones lentas que no superan los umbrales cortos.',
      holdDuration: 'Duración del bloqueo temporal',
      holdDurationHelp: 'Tiempo durante el cual las solicitudes de URL de reproducción de todas las sesiones y dispositivos de la cuenta detectada reciben HTTP 429. Las demás funciones de la API continúan disponibles.',
      maxRequestsWindow: 'Máximo de solicitudes en la ventana de frecuencia',
      maxRequestsWindowHelp: 'Cantidad permitida de solicitudes de URL de reproducción dentro de la ventana de frecuencia. La siguiente solicitud que exceda este valor activa la detección.',
      maxDistinctShort: 'Máximo de contenidos distintos en la ventana corta',
      maxDistinctShortHelp: 'Cantidad permitida de contenidos VOD diferentes dentro de la ventana corta. Solicitar varias veces el mismo contenido cuenta como un solo contenido distinto.',
      maxRequestsLong: 'Máximo de solicitudes en la ventana larga',
      maxRequestsLongHelp: 'Cantidad total permitida de solicitudes de URL de reproducción durante la ventana larga. La siguiente solicitud que exceda este valor activa la detección.',
      maxDistinctLong: 'Máximo de contenidos distintos en la ventana larga',
      maxDistinctLongHelp: 'Cantidad permitida de contenidos VOD diferentes solicitados durante la ventana larga. Este límite detecta la extracción gradual del catálogo.',
    },
    layouts: {
      default: 'Predeterminado',
      verticalMenu: 'Menú vertical',
      hospitality: 'Hoteles y residencias',
      modern: 'Moderno',
    },
  },
  contentPlanning: {
    title: 'Planificación de contenido',
    subtitle: 'Asigna y da seguimiento a cargas de películas, episodios y series completas.',
    create: 'Crear tarea', createTitle: 'Crear tarea de carga', created: 'Tarea creada.',
    updated: 'Tarea actualizada.', saveError: 'No se pudo guardar la tarea.',
    search: 'Buscar tareas…', myTasks: 'Mis tareas', allStatuses: 'Todos los estados',
    allTypes: 'Todos los tipos', allPriorities: 'Todas las prioridades', loading: 'Cargando…',
    empty: 'No hay tareas que coincidan con estos filtros.', previous: 'Anterior', next: 'Siguiente',
    assign: 'Asignar', unassigned: 'Sin asignar', start: 'Iniciar', block: 'Bloquear',
    resume: 'Reanudar', complete: 'Completar', blockedReasonPrompt: '¿Por qué está bloqueada esta tarea?',
    type: 'Tipo de contenido', taskTitle: 'Título', description: 'Descripción',
    priority: 'Prioridad', dueDate: 'Fecha límite', assignee: 'Responsable',
    tmdbId: 'ID de TMDB', showTmdbId: 'ID TMDB de la serie', season: 'Temporada',
    episode: 'Episodio', cancel: 'Cancelar', selectTmdbContent: 'Buscar contenido en TMDB',
    selectShow: 'Buscar serie principal', loadEpisode: 'Cargar episodio',
    tmdbError: 'No se pudieron cargar los detalles de TMDB.',
    createEpisodeRange: 'Crear paquete de trabajo por episodios',
    createEpisodeRangeHelp: 'Previsualiza un rango y crea una tarea agrupada con una tarea individual por cada episodio seleccionado.',
    seasonFrom: 'Temporada desde', seasonTo: 'Temporada hasta',
    episodeFrom: 'Episodio desde', episodeTo: 'Episodio hasta',
    previewEpisodes: 'Previsualizar', include: 'Incluir', airDate: 'Fecha de emisión',
    availability: 'Estado', available: 'Disponibles', alreadyUploaded: 'Ya cargados',
    alreadyPlanned: 'Ya planificados', uploaded: 'Cargado', planned: 'Planificado',
    ready: 'Disponible', createSelected: 'Crear tareas seleccionadas',
    batchCreated: 'Se crearon {count} tareas de episodios.',
    episodeProgress: '{completed}/{total} episodios completados',
    workPackage: 'Paquete de trabajo', packageEpisode: 'Episodio del paquete',
    types: { MOVIE: 'Película', EPISODE: 'Episodio', TV_SHOW: 'Serie completa' },
    status: {
      TODO: 'Pendiente', IN_PROGRESS: 'En progreso', BLOCKED: 'Bloqueada',
      COMPLETED: 'Completada', CANCELLED: 'Cancelada'
    },
    priorities: { LOW: 'Baja', NORMAL: 'Normal', HIGH: 'Alta', URGENT: 'Urgente' }
  }
};
